import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { CustomCbDefFieldsStyles } from '../../../styles/CustomStyles';
import { AppConfig } from '../../../AppConfig';

export class CrmCustomFieldsBase extends BaseEntityPage {
  constructor(props, settings) {
    super(props);
    this.pageTitle = Helper.getString(settings.pageTitleKey)
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.groupId = settings.groupIdKey + this.orgId
    this.entityAttrName = 'items'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['items', this.groupId + '-all'], queryParams: { orgId: this.orgId, groupId: this.groupId, pb: 'fieldDefCrmCustomFields' } },
    ]
    this.tableHeadersMap = {
      Order: (current) => { return current.order },
      'Key / Label': (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.uiKey}</span>
            <br/>
            <span className={css(Styles.spanValue)}>{current.label}</span>
          </div>
        )
      },
      Type: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.iType}</span>
          </div>
        )
      },
      Status: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.state || 'LIVE'}</span>
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      orgId: this.orgId
    }
  }

  onFetchSuccess(results) {
    this.fieldDefCrmCustomFields = results[0].fieldDefCrmCustomFields
    this.formDefinition = this.fieldDef = JSON.parse(JSON.stringify(this.fieldDefCrmCustomFields))
    this.setState({
      items: Helper.sortDictArray(Helper.dictToArray(results[0].items))
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.formDefinition.disableAlwaysFormFields = []
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: this.entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['items', this.groupId + '-all'],
        queryParams: {orgId: this.orgId, groupId: this.groupId},
      }),
    })
  }

  onEdit(current) {
    this.formDefinition.disableAlwaysFormFields = ['iType']
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['items', this.groupId + '-all'],
        queryParams: {orgId: this.orgId, groupId: this.groupId},
      }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'del', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['items', this.groupId + '-all'],
        queryParams: {orgId: this.orgId, groupId: this.groupId},
      }),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    return actions
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomCbDefFieldsStyles : StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})